import { render, staticRenderFns } from "./MonitoringPoint.vue?vue&type=template&id=f161e988&scoped=true&"
import script from "./MonitoringPoint.vue?vue&type=script&lang=js&"
export * from "./MonitoringPoint.vue?vue&type=script&lang=js&"
import style0 from "./MonitoringPoint.vue?vue&type=style&index=0&id=f161e988&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f161e988",
  null
  
)

export default component.exports